import { startsWith, endsWith } from "lodash-es";
import Rules from "./Rules";

class ProductRules extends Rules {
  static register: $TSFixMe;

  static rules = {};

  static find = (
    manufacturerName: $TSFixMe,
    productCode: $TSFixMe,
    isPublicTenant: $TSFixMe,
  ) => {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (isPublicTenant && ProductRules.rules[manufacturerName]) {
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (ProductRules.rules[manufacturerName][productCode]) {
        // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        return new ProductRules.rules[manufacturerName][productCode]();
      }

      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      const wildcardKeys = Object.keys(ProductRules.rules[manufacturerName])
        .filter((key) => endsWith(key, "*"))
        ?.map((key) => key.replace("*", ""));
      const matchingKey = wildcardKeys?.find((key) =>
        startsWith(productCode, key),
      );

      if (matchingKey) {
        // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        return new ProductRules.rules[manufacturerName][`${matchingKey}*`]();
      }
    }

    return new ProductRules();
  };

  showEditValueButton() {
    return true;
  }

  supportHeartBeatVerificationDirectly() {
    return false;
  }

  convertDisplayValues(
    asset: $TSFixMe,
    instrumentations: $TSFixMe,
    displayValues: $TSFixMe,
  ) {
    return displayValues;
  }

  nameForValueKey(key: $TSFixMe) {
    return key;
  }

  hasValueKeyTranslation() {
    return false;
  }

  showBuildUpIndexContextInHistory() {
    return false;
  }

  showHBSIContextInHistory() {
    return false;
  }
}

ProductRules.register = (
  manufacturerName: $TSFixMe,
  productCode: $TSFixMe,
  clazz: $TSFixMe,
) => {
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  if (!ProductRules.rules[manufacturerName]) {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    ProductRules.rules[manufacturerName] = {};
  }
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  ProductRules.rules[manufacturerName][productCode] = clazz;
};

export default ProductRules;
